import React from "react";
import { Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { appColors } from "../../constants/theme";

const BackNavigationButton = ({
  fallbackPath = "/",
  fallbackLabelKey,
  fallbackLabel,
  stateKey = "from",
  sx,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const fromState = location.state?.[stateKey] ?? location.state?.from;

  const defaultLabel =
    fallbackLabel ||
    (fallbackLabelKey ? t(fallbackLabelKey) : undefined) ||
    t("back") ||
    t("go_back") ||
    "Geri";

  let targetPath = fallbackPath;
  let targetLabel = defaultLabel;
  let targetState;

  if (fromState) {
    if (typeof fromState === "string") {
      targetPath = fromState;
    } else if (typeof fromState === "object") {
      if (fromState.path) {
        targetPath = fromState.path;
      }
      if (fromState.label) {
        targetLabel = fromState.label;
      } else if (fromState.labelKey) {
        targetLabel = t(fromState.labelKey);
      }
      if (fromState.state) {
        targetState = fromState.state;
      }
    }
  }

  const handleClick = () => {
    if (targetState) {
      navigate(targetPath, { state: targetState });
    } else if (targetPath === "goBack") {
      navigate(-1);
    } else {
      navigate(targetPath);
    }
  };

  return (
    <Button
      startIcon={<ArrowBack />}
      onClick={handleClick}
      sx={{
        mb: 1.5,
        color: appColors.gray500,
        textTransform: "none",
        fontWeight: 600,
        fontSize: "1rem",
        px: 1.5,
        py: 0.5,
        "&:hover": {
          bgcolor: appColors.gray50,
        },
        ...sx,
      }}
    >
      {targetLabel}
    </Button>
  );
};

export default BackNavigationButton;
